<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="驾驶员">
              <a-input v-model.trim="queryParam.name" placeholder="请输入驾驶员姓名"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="手机号">
              <a-input v-model.trim="queryParam.phone"
                       placeholder='请输入手机号码' />

            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="企业名称">
                <a-input v-model.trim="queryParam.companyName" placeholder="请输入所属企业名称"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
               <a @click="toggleAdvanced" style="margin-left: 8px">
                 {{ advanced ? '收起' : '展开' }}
                 <a-icon :type="advanced ? 'up' : 'down'"/>
               </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleSave()">新增</a-button>
      <a-upload
        accept=".xls,.xlsx"
        :showUploadList="false"
        :action= "config.importDriverUrl"
        :beforeUpload="beforeUpload"
        @change="handleChange"
      >
        <a-button style="margin-left: 8px" type="primary" icon="plus" >导入</a-button>
      </a-upload>

      <a-button style="margin-left: 8px" type="primary" @click="downLoad()">模板下载</a-button>
      <a-button style="margin-left: 8px" type="primary" @click="handleExport()">导出</a-button>
    </div>
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1340 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
      <span class="blacktr" v-if="blackListOpen && $store.getters.blackList['3'] && $store.getters.blackList['3'][record.id]">
      </span>
    </span>

      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
         <a-dropdown>
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item  v-if="blackListOpen"><a v-if="blackListOpen && (!$store.getters.blackList['3'] || !$store.getters.blackList['3'][record.id])"
              @click="handleBlack(record)">拉黑</a>
              <span v-else>已黑</span></a-menu-item>
            <a-menu-item><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>

      </span>
    </s-table>
    <a-modal
      title="操作"
      style="top: 10px;"
      :width="800"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item
          label="运输单位"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
          validateStatus="warning"
        >
          <a-select
            :filterOption="filterOption"
            v-model="mdl.corpLogisticsId"
            placeholder="请选择运输单位"
            :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
          >
            <a-select-option v-for="(item, index) in corpLogisticsSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="准驾车型"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
          validateStatus="warning"
        >
          <a-select
            :filterOption="filterOption"
            v-model="mdl.quasiVehicleType"
            placeholder="请选择准驾车型"
            :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
          >
            <a-select-option v-for="(item, index) in quasiVehicleTypeSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="驾驶员"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="驾驶员" v-model="mdl.name"
                   v-decorator="['name', { initialValue: mdl.name, rules: [{ required: true, message: '请输入驾驶员名'}]}]"/>
        </a-form-item>
        <a-form-item
          label="身份证号"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="身份证号" v-model="mdl.idcard"
                   @blur="validateIdCardBlur"/>
        </a-form-item>

        <a-form-item
          label="手机号"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="手机号" v-model="mdl.phone" v-decorator="['phone', { initialValue: mdl.phone, rules: [{ required: true,max:11, message: '请输入正确格式长度手机号码'}]}]" @blur="validatePhoneBlur"/>
        </a-form-item>
        <a-form-item
          label="联系地址"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="联系地址" v-model="mdl.address"/>
        </a-form-item>
        <a-form-item
          label="邮箱"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="邮箱" v-model="mdl.eMail"/>
        </a-form-item>
        <a-form-item
          label="驾驶证号"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="驾驶证号" v-model="mdl.drivingNo"
                   />
        </a-form-item>
        <a-form-item
          label="驾驶证有效期"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
<!--
          <a-date-picker v-model="mdl.drivingIndate" showTime format="yyyy-MM-dd"  v-decorator="['drivingIndate', { initialValue: mdl.drivingIndate, rules: [{ required: true,formatDate:'yyyy-MM-dd', message: '请选择行驶证有效期'}]}]"/>
-->
          <a-date-picker v-model="mdl.drivingIndate">  </a-date-picker>
          <!-- <a-date-picker v-model="mdl.drivingIndate" v-decorator="['drivingIndate', { initialValue: mdl.drivingIndate, rules: [{ required: true,formatDate:'yyyy-MM-dd', message: '请选择行驶证有效期'}]}]">
          </a-date-picker>-->
        </a-form-item>
        <a-form-item
          label="驾驶员从业资格证号"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="驾驶员从业资格证号" v-model="mdl.certificationNo"/>
        </a-form-item>
        <a-form-item
          label="从业资格证有效期"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-date-picker v-model="mdl.certificationIndate">
          </a-date-picker>
        </a-form-item>


       <!-- <a-form-item
          label="供应商"
          validateStatus="warning"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
        <a-select
          :filterOption="filterOption"
          v-model="mdl.corpSupplierId"
          placeholder="请选择供应商"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
          >
          <a-select-option v-for="(item, index) in corpSupplierSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
        </a-form-item>-->
      </a-form>
    </a-modal>

    <a-modal
      title="拉黑"
      :width="640"
      v-model="blackModel" @ok="handleBlackOk" 
      :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="驾驶员" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-input disabled placeholder="企业名" v-model="black.name" id="role_name" />
        </a-form-item>

        <a-form-item label="类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-select disabled v-model="black.type" placeholder="请选择" >
            <a-select-option v-for="(item, index) in typeSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="拉黑原因" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-textarea :rows="1" v-model="black.remark" placeholder="..." id="describe" 
            v-decorator="['remark',
            { initialValue: black.remark, rules: [{ required: true, message: '请输入拉黑原因'}]}]"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import { STable } from '@/components'
  import { driverPage, driverDelete, driverSave, driverUpdate } from '@/api/basic'
  import {  corpLogisticsList, getCorpSupplierList } from '@/api/basic'
  import { blackListSave } from '@/api/basic'
  import { formatDate } from '@/utils/date'
  import moment from 'moment'
  import config from '@/config/defaultSettings'
  import Bus from '@/layouts/bus'
  import { getBizTextByValue } from '@/utils/util'

  export default {
    name: 'DriverList',
    components: {
      STable
    },
    data () {
      return {
        pageSizeOptionsList:['10'],
        description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        visible: false,
        confirmLoading: false,
        blackModel: false,
        form: this.$form.createForm(this),
        mdl: {},
        black: {},
        blackListOpen: config.blackListOpen,

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '#',
            scopedSlots: { customRender: 'serial' },
            width: '40px',
            fixed: 'left'
          },
          {
            title: '物流企业',
            dataIndex: 'corpLogisticsName',
            width: '200px',
          },
          {
            title: '准驾车型',
            dataIndex: 'quasiVehicleType',
            width: '150px',
            customRender: (text, record) => {
              return getBizTextByValue(this.quasiVehicleTypeSelect, record.quasiVehicleType, text)
            }
          },
          {
            title: '驾驶员',
            dataIndex: 'name',
            width: '200px',
          },
          {
            title: '手机号',
            dataIndex: 'phone',
            width: '260px',
          },
          {
            title: '驾驶证有效期',
            dataIndex: 'drivingIndate',
            width: '180px',
            customRender: (text) => {
              const date = new Date(text)
              return formatDate(date, 'yyyy-MM-dd')
            }
          },
          {
            title: '驾驶证号',
            dataIndex: 'drivingNo',
            width: '180px',
          },
          /*{
            title: '供应商名称',
            dataIndex: 'corpSupplierName',
            width: '240px',
          },*/
          {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
          {
            title: '操作',
            width: '130px',
            fixed: 'right',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 所属菜单下拉
        corpSupplierSelect: null,
        corpLogisticsSelect: null,
        typeSelect: null,
        quasiVehicleTypeSelect : null,

        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return driverPage(Object.assign(parameter, this.queryParam))
            .then(res => {
              setTimeout(() => {
                $('.blacktr').parents('tr').css("background-color", "#ddd")
              }, 1000);
              return res.data
            })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        optionAlertShow: true
      }
    },
    created () {
      this.tableOption()
      this.loadSelect()
    },
    mounted() {
      // setTimeout(() => {
      //   $('.blacktr').parents('tr').css("border-left", "10px solid #000")
      // }, 1000);
    },
    methods: {
      moment,
      // 手机号校验事件
      validatePhoneBlur(e) {
        const validatePhoneReg = /^1[3456789]\d{9}$/
        if (e.target.value && !validatePhoneReg.test(e.target.value)) {
          const arr = [{
            message: '您输入的手机格式不正确!',
            field: 'phone',
          }]
          this.form.setFields({ phone: { value: e.target.value, errors: arr } })
        }
      },
      // 身份证号校验事件
      validateIdCardBlur(e) {
      //  const validateIdCardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        const validateIdCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        if (e.target.value && !validateIdCardReg.test(e.target.value)) {
          const arr = [{
            message: '您输入的身份证号格式不正确!',
            field: 'idcard',
          }]
          this.form.setFields({ idcard: { value: e.target.value, errors: arr } })
        }
      },

      loadSelect () { // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = getCorpSupplierList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.corpSupplierSelect = res
        })

        new Promise(resolve => {
          const data = corpLogisticsList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.corpLogisticsSelect = res
        })
        this.typeSelect = this.$store.getters.codeList.basic_black_list_type
        this.quasiVehicleTypeSelect = this.$store.getters.codeList.quasi_driving_vehicle_type
      },

      filterOption (input, option) { // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      tableOption () {
        if (!this.optionAlertShow) {
          this.options = {
            alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
            rowSelection: {
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange
            }
          }
          this.optionAlertShow = true
        } else {
          this.options = {
            alert: false,
            rowSelection: null
          }
          this.optionAlertShow = false
        }
      },
      handleEdit (record) {

        const drivingIndateNumber=    record.drivingIndate

        if(drivingIndateNumber !=null ) {
          const date1 = new Date(drivingIndateNumber)
          const drivingIndateDateStr = formatDate(date1, "yyyy-MM-dd")
          const drivingIndateMoment = moment(drivingIndateDateStr, "yyyy-MM-dd")
          drivingIndateMoment._d = date1
          record.drivingIndate = drivingIndateMoment
        }
        const certificationIndateNumber=    record.certificationIndate
        if(certificationIndateNumber !=null ) {
          const date2 = new Date(certificationIndateNumber)
          const certificationIndateStr = formatDate(date2, "yyyy-MM-dd")
          const certificationIndateMoment = moment(certificationIndateStr, "yyyy-MM-dd")
          certificationIndateMoment._d = date2
          record.certificationIndate = certificationIndateMoment
        }
        this.mdl = Object.assign({}, record)
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
      },
      handleSave () {
        this.mdl = {}
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
      },

      handleOk () {
        // 身份证号校验事件
        var idcard=this.mdl.idcard
        const validateIdCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        if (idcard && !validateIdCardReg.test(idcard)) {
          const arr = [{
            message: '您输入的身份证号格式不正确!',
            field: 'idcard',
          }]
          this.form.setFields({ idcard: { value: idcard, errors: arr } })
          return
        }
        // 手机号验证
        var phone=this.mdl.phone
        const validatePhoneReg = /^1[3456789]\d{9}$/
        if (phone && !validatePhoneReg.test(phone)) {
          const arr = [{
            message: '您输入的手机格式不正确!',
            field: 'phone',
          }]
          this.form.setFields({ phone: { value: phone, errors: arr } })
          return
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            if (this.mdl.id !== undefined) {
              driverUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
            } else {
              driverSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
            }
          }
        })
      },

      handleBlack (record) {
        this.black["type"] = '3'
        this.black["name"] = record.name
        this.black["recordId"] = record.id
        this.black["remark"] = ''
        this.form = this.$form.createForm(this)
        this.blackModel = true
      },

      handleBlackOk ({ commit }) {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            blackListSave(Object.assign({}, this.black))
              .then(res => {
                if (res.code === '0') {
                  let blackList = this.$store.getters.blackList
                  if (!blackList['3'])
                    blackList['3'] = {}
                  blackList['3'][this.black.recordId] = this.black
                  this.$store.commit('SET_BLACK', blackList)
                  this.$refs.table.refresh()
                  this.blackModel = false
                  // setTimeout(() => {
                  //   $('.blacktr').parents('tr').css("border-left", "10px solid #000")
                  // }, 1000);
                } else {
                  this.$message.error(res.message)
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          }
        })
      },
      handleDel (record) {
        var nthis = this
        this.$confirm({
          title: '提示',
          content: '确定要删除吗?',
          onOk () {
            nthis.confirmLoading = true
            return driverDelete(Object.assign(record, nthis.queryParam))
              .then(res => {
                  if( res.code ==='0') {
                    nthis.$refs.table.refresh()
                  }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                nthis.confirmLoading = false
              })
          },
          onCancel () {
          }
        })
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
        handleChange (info) {
          if (info.file.status === 'uploading') {
            Bus.$emit('showSpinning', true, "准备导入...")
          }

          if (info.file.status === 'done') {
            Bus.$emit('showSpinning', false)
            if (info.file.response && info.file.response.code === '0'){
              this.$message.success('导入成功！')
              this.$refs.table.refresh()
            }else{
              this.$message.error(info.file.response.message)
            }
          }
        },

      beforeUpload (file) {

      },
      downLoad(){
        let url=this.config.downLoadMouldUrl+"驾驶员.xlsx"
        window.location.href=url
      },
      handleExport() {
        var name=this.queryParam.name
        var phone=this.queryParam.phone
        var companyName=this.queryParam.companyName
        if(!name){
          name=''
        }
        if(!phone){
          phone=''
        }
        if(!companyName){
          companyName=''
        }
        const token = Vue.ls.get(ACCESS_TOKEN)
        window.location.href = this.config.downDriverUrl + '&accessToken=' + token +'&name=' +name +'&phone=' +phone +'&companyName=' +companyName
      },
    },
  }
</script>


<style scoped>
  /deep/ .ant-form-item {
        margin-bottom: 10px;
      }
</style>